
/**default**/
var wW = $(window).innerWidth(),
    wsroll = $(window).scrollTop(),
    pageId = $(".wp").attr('id'),
    pageTh = $(".wp").data('th'),
    pageMenu = $(".wp").data('page');
    console.log('pageId = ' + pageId);
    console.log('pageTh = ' + pageTh);

if(pageId == 'index'){
    var $bn_h = $(".bn_H").height();
}else{
    // var $bn_h = $(".bn_H").height() * 0.5;
    var $bn_h = 200;
}

if(wW > 1024){
    var header_h = $("#header").height() + 100;
    console.log('header_h = ' + header_h);
}else{
    var header_h = $("#header").height();
    console.log('header_h = ' + header_h);
}

imgFill();

$('main').css('opacity',"1");

svg();

var lightcase = require('lightcase');

var AOS = require('aos');
AOS.init({
    duration: 800,
    offset: 100,
});
if (document.readyState == 'complete')
{
    AOS.refresh();
}

$(".history-list").each(function(){
    AOS.init({startEvent: 'load'});
});

// popper.js
window.popper = require('popper.js').default;

var trigger_size = [576, 768, 1025];
$(window).resize(function () {
    trigger_size.forEach(function (ele) {
        if (wW > ele) {
            $(window).width() <= ele ? location.reload() : "";
        } else {
            $(window).width() > ele ? location.reload() : "";
        }
    });
});

if (!/Android/i.test(window.navigator.userAgent)) {
    $(".scrollbarX").each(function() {
        $(this).mCustomScrollbar({
            axis: "x",
            mouseWheel:{ enable: false }
        });
    });
}



//menu start
$('.search-btn').click(function(){
    $(this).parent('.search').toggleClass('active');
    $(this).siblings('.search-box').slideToggle();
    $(this).parents('#header').toggleClass('searchOpen');
});
$('.search-box .zoom .close-btn').click(function(){
    $(this).parents('.search').toggleClass('active');
    $(this).parents('.search-box').slideToggle();
    $(this).parents('#header').toggleClass('searchOpen');
});

$(window).scroll(function(){
    headerScroll();
});

//黑色文字menu
if(pageMenu == "blackmenu"){
    $('#header').addClass("blackSet");
}

if(wW > 1024){
    $("#header").hover(function(){
        $(this).toggleClass("active");
        $('.nav-zoom .hasSubmenu[data-page="' + pageId + '"]').toggleClass('current');
        $('.nav-zoom .hasSubmenu[data-page="' + pageId + '"]').children('ul.submenu').toggleClass("open");
        $('.nav-zoom .hasSubmenu ul.submenu li[data-title="' + pageTh + '"]').addClass('active');
    });
    $('.nav-zoom .hasSubmenu').hover(function(){
        $(this).toggleClass("active");
        $(this).children('.submenu').toggleClass("active");
    });
    headerScroll();
}else{
    $('.menu-toggle').click(function(){
        $(this).children('.nav__toggle-btn').toggleClass('active');
        $('.nav-zoom nav').slideToggle();
        $('.nav-zoom .hasSubmenu[data-page="' + pageId + '"]').addClass('current');
        $('.nav-zoom .hasSubmenu[data-page="' + pageId + '"]').children('.submenu').addClass('current');
        $('.nav-zoom .hasSubmenu ul.submenu li[data-title="' + pageTh + '"]').addClass('active');
        $('.search-box').slideUp();
    });

    $('.nav-zoom .hasSubmenu .menulink').click(function(e){
        e.preventDefault();
        $(this).parent('li').siblings('li').removeClass('active');
        $(this).parent('li').toggleClass('active');
        // $(this).parent('li').siblings('li').children('.submenu').removeClass('active');
        // $(this).siblings('.submenu').toggleClass('active');
        $(this).siblings('.submenu').slideToggle();
        $(this).parent('li').siblings('li').children('.submenu').slideUp();

    });

    $('.search-btn').click(function(){
        $('.menu-toggle').children('.nav__toggle-btn').removeClass('active');
        $('.nav-zoom nav').slideUp();
    });
}

//menu end

//footer
$('.gotop').click(function(){$('html,body').animate({scrollTop: 0},1000);});


// index js
$("#index").each(function(){
    $(".index_banner .slider").slick({
        lazyLoad: 'ondemand',
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay:true,
        autoplaySpeed: 4500,
        speed:1000,
        arrows:true,
        dots: true,
        pauseOnHover:false,
        customPaging : function(slider, i) {
            var thumb = $(slider.$slides[i]).data();
            return '<a class="dot">0'+(i+1)+'</a>';
        },
        responsive: [
            {
                breakpoint: 1025,
                    settings:{
                        customPaging : function(slider, i) {
                            var thumb = $(slider.$slides[i]).data();
                            return '<a class="dot"></a>';
                        }
                    }
            },
        ]
    });
    $(".series-box .slider").slick({
        lazyLoad: 'ondemand',
        variableWidth: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay:true,
        autoplaySpeed: 2000,
        speed:800,
        arrows:true,
        // infinite: false,
        responsive: [
            {
                breakpoint: 576,
                settings:{
                    slidesToShow: 2,
                    variableWidth: false,
                }
            }
        ]
    });

});

// products js
$("#PRODUCTS").each(function(){
    $('.gridder-list').each(function(index) {
        if( wW > 576){
            var series_height = 0;
            if ($(this).height() >= series_height){
                series_height = $(this).height();
                $('.gridder-list').height(series_height);
            }
        }
    });
    if(wW > 1024){
        var head_h = $("#header").height() + 50;
    }else{
        var head_h = $("#header").height();
    }
    $('.pd-list_top .scroll-down').click(function(){
        $("html,body").animate({scrollTop:$(".pd-list-page").offset().top - head_h},800);
    });

    $('.pd_list-btn a').click(function(e){
        e.preventDefault();
        $("html,body").animate({scrollTop:$(".pd-list-page").offset().top - head_h},800);
    });

    // products-list Call Gridder
    $(".gridder").gridderExpander({
        scrollOffset: header_h,
        scrollTo: "panel", // "panel" or "listitem"
        animationSpeed: 800,
        animationEasing: "easeInOutExpo",
        showNav:false,                      //顯示導航
        closeText:"<span class='icon-close'></span>",
    });

    //product
    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay:true,
        autoplaySpeed: 3000,
        speed:800,
        asNavFor: '.slider-nav'
      });
    $('.slider-nav').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: false,
        centerMode: false,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1025,
                settings:{
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 576,
                settings:{
                    slidesToShow: 3,
                }
            },
        ]
    });

    // lightcase
    $('[data-rel^="lightcase"]').lightcase({
        showCaption: false,
        showSequenceInfo: false,
        maxHeight: 800,
        onStart: {
            foo: function() {
                $('.slider-for').slick('slickPause');
            }
          },
          onClose: {
            grault: function() {
                $('.slider-for').slick('slickPlay');
            }
          }
    });

    $(".scrollbarY").mCustomScrollbar({
        axis:"y",
        theme:"dark-thick",
    });

    //呼叫彈跳視窗
    // $('#modal-inquiry').modal('show');
});



$(".related-box .slider").slick({
    lazyLoad: 'ondemand',
    slidesToShow: 3,
    slidesToScroll: 1,
    // autoplay:true,
    // autoplaySpeed: 3500,
    // speed:800,
    arrows:true,
    dots: false,
    pauseOnHover:false,
    customPaging : function(slider, i) {
        var thumb = $(slider.$slides[i]).data();
        return '<a class="dot">0'+(i+1)+'</a>';
    },
    responsive: [
        {
            breakpoint: 768,
                settings:{
                    slidesToShow: 2,
                }
        },
    ]
});

$(".cooperation-slider .slider").slick({
    lazyLoad: 'ondemand',
    slidesToShow: 7,
    slidesToScroll: 1,
    infinite:false,
    arrows:true,
    dots: false,
    responsive: [
        {
            breakpoint: 1200,
                settings:{
                    slidesToShow: 6,
                }
        },{
            breakpoint: 992,
                settings:{
                    slidesToShow: 4,
                }
        },
        {
            breakpoint: 768,
                settings:{
                    slidesToShow: 3,
                }
        },
        {
            breakpoint: 576,
                settings:{
                    slidesToShow: 2,
                }
        },
    ]
});

var img_height = 0;
$('.certification-list .item .img').each(function(index) {
    if ($(this).height() >= img_height)
    img_height = $(this).height();
});
if( wW > 576){
    $('.certification-list .item .img').height(img_height);
}

/* ==========================================================================
		function
    ==========================================================================*/
    function headerScroll(){
        console.log("page bn height = " + $bn_h);
        if ($(window).scrollTop() > $bn_h){
            $('#header').addClass('scroll');
            submenuScrollOpen();
        }
        else if($(window).scrollTop() <= $bn_h) {
            $('#header').removeClass('scroll');
            submenuScrollClose();
        }
    }

    function submenuScrollOpen(){
        $('.nav-zoom .hasSubmenu[data-page="' + pageId + '"]').addClass('current');
        $('.nav-zoom .hasSubmenu[data-page="' + pageId + '"]').children("ul.submenu").addClass('open');
        $('.nav-zoom .hasSubmenu ul.submenu li[data-title="' + pageTh + '"]').addClass('active');
    }

    function submenuScrollClose(){
        $('.nav-zoom .hasSubmenu ul.submenu').removeClass('open');
        $('.nav-zoom .hasSubmenu[data-page="' + pageId + '"]').removeClass('current');
        $('.nav-zoom .hasSubmenu[data-page="' + pageId + '"]').children('ul.submenu').removeClass("open");
    }

    function svg() {
        jQuery('img.svg').each(function () {
            var $img = jQuery(this);
            var imgID = $img.attr('id');
            var imgClass = $img.attr('class');
            var imgURL = $img.attr('src');

            jQuery.get(imgURL, function (data) {
                // Get the SVG tag, ignore the rest
                var $svg = jQuery(data).find('svg');

                // Add replaced image's ID to the new SVG
                if (typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }
                // Add replaced image's classes to the new SVG
                if (typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass + ' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');

                // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
                if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                    $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
                }

                // Replace image with new SVG
                $img.replaceWith($svg);

            }, 'xml');

        });
    }

    // imgFill
    function imgFill() {
        $('.jqimgFill').imgLiquid();
        $('.jqimgFill').each(function () {
        const $this = $(this),
                $picture = $this.find('picture'),
                $source = $picture.children('source'),
                src = $this.find('img').attr('src'),
                srcset = $source.attr('srcset');
        let node, minmax, breakpoint;
        let windowWidth = window.innerWidth;
        if ($picture.length) {
            node = $source.attr('media').replace(/\(|\)| /g, '');
            minmax = node.split(':')[0];
            breakpoint = node.split(':')[1];
            if (minmax === 'min-width') {
            if (windowWidth >= parseFloat(breakpoint)) {
                $this.css('background-image', 'url("' + srcset + '")');
            } else {
                $this.css('background-image', 'url("' + src + '")');
            }
            } else if (minmax === 'max-width') {
            if (windowWidth <= parseFloat(breakpoint)) {
                $this.css('background-image', 'url("' + srcset + '")');
            } else {
                $this.css('background-image', 'url("' + src + '")');
            }
            } else if (minmax === 'orientation') {
            let wRatio = Math.abs(window.innerWidth / window.innerHeight);
            if (breakpoint === 'portrait' && wRatio <= 1) {
                $this.css('background-image', 'url("' + srcset + '")');
            } else if (breakpoint === 'portrait' && wRatio > 1) {
                $this.css('background-image', 'url("' + src + '")');
            }
            if (breakpoint === 'landscape' && wRatio > 1) {
                $this.css('background-image', 'url("' + srcset + '")');
            } else if (breakpoint === 'landscape' && wRatio <= 1) {
                $this.css('background-image', 'url("' + src + '")');
            }
            }
        }
        });
    }